/*
 * QuotationConstants
 */

export const GET_QUOTATION = 'ideal/Quotation/GET_QUOTATION';
export const PRINT_QUOTATION = 'ideal/Quotation/PRINT_QUOTATION';
export const UPDATE_QUOTATION_STATUS =
  'ideal/Quotation/UPDATE_QUOTATION_STATUS';
export const QUOTATION_RECEIVED = 'ideal/Quotation/QUOTATION_RECEIVED';
export const DISPLAY_QUOTATION_ASSISTANT =
  'ideal/Quotation/DISPLAY_QUOTATION_ASSISTANT';
